import * as React from "react";
function SvgVehicleBlacklist(props: ISvgIcons) {
  return (
    <svg
      width={props.size}
      height={props.size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={"0 0 24 24"}
      {...props}
    >
      <g
        stroke={props.color}
        strokeWidth={props.weight}
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect={"non-scaling-stroke"}
      >
        <circle cx={17.502} cy={16} r={6} />
        <path d="M13.26 20.241l8.484-8.483M3.203 6.358L4.952 2.46A2.251 2.251 0 017.061 1h8.882c.939-.001 1.78.58 2.109 1.46l1.751 3.9M1.752 12.8v1.7a1.5 1.5 0 103 0V13M4.377 9.25a.375.375 0 00-.375.375M4.752 9.625a.375.375 0 00-.375-.375M4.377 10a.375.375 0 00.375-.375M4.002 9.625c0 .207.168.375.375.375" />
        <path d="M21.6 7.75a3 3 0 00-2.6-1.5H4a3 3 0 00-3 3v2.25A1.5 1.5 0 002.5 13h6" />
      </g>
    </svg>
  );
}
export default SvgVehicleBlacklist;
